import { ListActionButton, ModalCustom, Notification } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import ModalContent from "./ModalContent/ModalContent";
import { Button, Col, Row, Space, Table, Typography, Upload } from "antd";
import { columns } from "./config";
import { PaginationProps } from "antd/lib/pagination";
import { pharmacyStoreService } from "api";
import { renderSTT } from "helper/common";
import { UploadOutlined } from "@ant-design/icons";
import { useAppSelector } from "redux/hooks";
import { ExcelSVG } from "assets";
import DeleteContent from "./DeleteContent/DeleteContent";
// |import {dataFields} from "./config";

const BiddingDecision = () => {
  const modalRef = useRef<any>();
  const deleteModalRef = useRef<any>(); // Ref mới cho modal xóa
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [type, setType] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [record, setRecord] = useState(null);
  const [total, setTotal] = useState(0);
  const [listBidDecision, setListBidDecision] = useState<any>();
  const [loading, setLoading] = useState(false);
  const expandRef = useRef<any>();
  const [paramss, setParamss] = useState<any>({});
  const [refreshData, setRefreshData] = useState(false);
  const nameCatalog = "quyết định thầu";
  const namedelete = "Xóa";
  useEffect(() => {
    getListBidDecision(page, limit);
  }, [page, limit]);

  columns.find((e) => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteBidDecision(_record.id);
        }}
        editFunction={() => {
          setType("Sửa");
          setRecord(_record);
          modalRef.current?.openModal();
        }}
      ></ListActionButton>
    );
  };
  const showDeleteModal = () => {
    deleteModalRef.current?.openModal();
  };
  const closeDeleteModal = () => {
    setIsDeleteModalVisible(false);
    if (deleteModalRef.current) {
      deleteModalRef.current.closeModal();
    }
  };
  const getListBidDecision = async (pageInput = page, limitIput = limit) => {
    setLoading(true);
    try {
      const res = await pharmacyStoreService.getListBidDecision(
        pageInput - 1,
        limitIput
      );
      setListBidDecision(res.body.data);
      setTotal(res.body.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", `Đã xảy ra lỗi khi lấy danh sách ${nameCatalog}`);
    }
  };
  const deleteBidDecision = async (id) => {
    try {
      const res = await pharmacyStoreService.deleteBidDecision(id);
      Notification("success", "Đã xóa dữ liệu vừa chọn");

      await getListBidDecision();
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xóa dữ liệu");
    }
  };
  useEffect(() => {
    _renderSTT(page, limit);
  }, [page, limit]);
  const _renderSTT = (page, limit) => {
    columns.find((e) => e.dataIndex == "stt").render = (
      value,
      _record,
      index
    ) => {
      return <>{renderSTT(index, page, limit)}</>;
    };
  };
  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    setPage(page);
    setLimit(pageSize);
  };

  const uploadFile = async (options: any) => {
    const file_size = options.file.size;
    try {
      const formData = new FormData();
      formData.append("files", options.file as Blob);

      const res = await pharmacyStoreService.uploadFileThau(formData);
      setPage(1);
      getListBidDecision(1, limit);
      setRefreshData((prev) => !prev);
      Notification("success", "Đã tải file thành công");
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
    return false;
  };
  const handleExportExcel = async () => {
    try {
      const res = await pharmacyStoreService.exportExcelBidDecision(paramss);
      const url = window.URL.createObjectURL(
        new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Báo-cáo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Notification("success", "Báo cáo đã được tải xuống");
    } catch (error) {
      console.error(error);
      Notification("error", "Đã xảy ra lỗi khi xuất báo cáo");
    }
  };
  const onClickExportArrive = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
    handleExportExcel();
  };

  return (
    <Space
      direction="vertical"
      className="BidDecision container"
      // style={{width: "100%"}}
    >
      <Row justify={"space-between"}>
        <Col>
          {" "}
          <div className="title">Danh mục {nameCatalog}</div>{" "}
        </Col>
        <Col>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                setType("Thêm");
                setRecord(null);
                modalRef.current?.openModal();
              }}
            >
              Thêm mới
            </Button>
            <Upload
              customRequest={uploadFile}
              accept=".xlsx"
              multiple
              showUploadList={false}
            >
              <Button
                type="primary"
                className="btn-sub"
                icon={<UploadOutlined />}
              >
                Import file
              </Button>
            </Upload>
            <Button
              type="default"
              onClick={onClickExportArrive}
              icon={<ExcelSVG />}
            >
              <Typography>Xuất báo cáo</Typography>
            </Button>
            <Button
              type="primary"
              onClick={showDeleteModal} // Sử dụng hàm mới để mở modal xóa
            >
              xóa
            </Button>
          </Space>
        </Col>
      </Row>
      <div className="container-table">
        <Table
          loading={loading}
          bordered
          columns={columns}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            onChange: onChange,
            total: total,
            pageSize: limit,
            current: page,
          }}
          scroll={{ y: 400 }}
          dataSource={listBidDecision}
        ></Table>

        <ModalCustom
          ref={modalRef}
          width={1000}
          title={`${type} ${nameCatalog}`}
        >
          <ModalContent
            nameCatalog={nameCatalog}
            data={record}
            getListBidDecision={getListBidDecision}
            type={type}
          ></ModalContent>
        </ModalCustom>
        <ModalCustom
          ref={deleteModalRef}
          width={500}
          title={`Xóa ${nameCatalog}`}
          onCancel={closeDeleteModal}
        >
          <DeleteContent
            closeModal={closeDeleteModal}
            nameCatalog={nameCatalog}
            refreshData={refreshData}
            getListBidDecision={getListBidDecision}
          />
        </ModalCustom>
      </div>
    </Space>
  );
};

export default BiddingDecision;
